import { Global, css } from '@emotion/react';

import * as React from 'react';

import EnterpriseLeadContainer from 'bundles/internal-enterprise/components/lead/EnterpriseLeadContainer';

// Global styles to reset the css definitions from `internal-common/styl/meterialism.css`
const globalStyles = css`
  html {
    font-size: inherit;
  }

  input[type='text'][class^='MuiInputBase-input'] {
    padding: 6px 0 7px 0;
  }

  legend {
    border-bottom: 0;
  }
`;

const EnterpriseLeadTool: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  return (
    <React.Fragment>
      <Global styles={globalStyles} />
      <EnterpriseLeadContainer>{children}</EnterpriseLeadContainer>
    </React.Fragment>
  );
};

export default EnterpriseLeadTool;
